import Header from "./Components/Header";
import Category from "./Components/category";
import TopRestaurant from "./Components/TopRestaurant";
import OnlineDelivery from "./Components/OnlineDelivery";
import Footer from "./Components/Footer";

function App() {
  return (
    <>
      <Header/>
      <Category/>
      <TopRestaurant/>
      <OnlineDelivery/>
      <Footer/>
    </>
  );
}

export default App;
